var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resources"},_vm._l((_vm.links),function(link){return _c('link-material',{key:link.url,attrs:{"linkUrl":link.url,"label":link.displayName}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }